/* wizardShell.component.js */

import wizardShellController from "./wizardShell.controller";

/**
 * @desc shell component for updated Wizard styling
 * @example <wizard-shell></wizard-shell>
 */

const wizardShell = {
    bindings: {
        tabs: '<',
        wizardTitle: '<',
        closeWizard: '<',
        saving: '<',
        onNavigation: '&',
        onSave: '&',
        onSaveProduct: '&',
        comparisonKeys: '<',
        validationKeys: '<'
    },
    controller: wizardShellController,
    controllerAs: 'wsvm',
    templateUrl: '/App/Shared/Components/wizardShell/wizardShell.tmpl.html'
};

export default wizardShell;